import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {WebmateBrowserModule} from "@webmate-web-core/shared/components/browser/webmate-browser.module";
import {CanvasModule} from "@webmate-web-core/shared/components/canvas/canvas.module";
import {TestSessionSummaryComponent} from "@webmate-web-core/shared/components/testmgmt/testsession-summary.component";
import {TestTypeComponent} from '@webmate-web-core/shared/components/testmgmt/test-type.component';
import {TooltipModule} from 'primeng/tooltip';
import {AvatarModule} from '@webmate-web-core/shared/components/avatar/avatar.module';
import {ExpeditionSpecComponent} from '@webmate-web-core/shared/components/testmgmt/expedition-spec.component';
import {URLModule} from '@webmate-web-core/shared/components/urls/urls.module';
import {BrowserSpecificationComponent} from '@webmate-web-core/shared/components/testmgmt/vehiclespecs/browser-specification.component';
import {IssueStatisticsSummaryComponent} from '@webmate-web-core/shared/components/testmgmt/issue-statistics-summary.component';
import {TestStatusComponent} from "@webmate-web-core/shared/components/testmgmt/test-status/test-status.component";
import {LiveExpeditionSpecComponent} from "@webmate-web-core/shared/components/testmgmt/live-expedition-spec.component";
import {OfflineExpeditionSpecComponent} from "@webmate-web-core/shared/components/testmgmt/offline-expedition-spec.component";
import {AccordionModule} from "primeng/accordion";
import {BrowserSessionModule} from "@webmate-web-core/shared/components/browsersession/browsersession.module";
import {FormsModule} from "@angular/forms";
import {TagsModule} from "@webmate-web-core/shared/components/tags/tags.module";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {FactsModule} from '@webmate-web-core/shared/components/facts/facts.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ButtonModule} from 'primeng/button';
import {TestStatusSwitcherComponent} from '@webmate-web-core/shared/components/testmgmt/test-status/test-status-switcher.component';
import {PopoverModule} from 'primeng/popover';
import {WmCalendarFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-calendar-format';
import {WmDateFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-date-format.pipe';
import {WmDifferenceFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-difference-format';
import {WmDurationFormatPipe} from '@webmate-web-core/shared/utils/pipes/wm-duration-format';

@NgModule({
    declarations: [
        TestSessionSummaryComponent,
        TestTypeComponent,
        ExpeditionSpecComponent,
        TestStatusComponent,
        TestStatusSwitcherComponent,
        BrowserSpecificationComponent,
        IssueStatisticsSummaryComponent,
        LiveExpeditionSpecComponent,
        OfflineExpeditionSpecComponent
    ],
    providers: [],
    imports: [
        CommonModule,
        WebmateBrowserModule,
        AccordionModule,
        BrowserSessionModule,
        FormsModule,
        CanvasModule,
        TagsModule,
        ProgressSpinnerModule,
        TooltipModule,
        AvatarModule,
        URLModule,
        BrowserSessionModule,
        FactsModule,
        FontAwesomeModule,
        ButtonModule,
        PopoverModule,
        WmCalendarFormatPipe,
        WmDateFormatPipe,
        WmDifferenceFormatPipe,
        WmDurationFormatPipe
    ],
    exports: [
        TestSessionSummaryComponent,
        TestTypeComponent,
        ExpeditionSpecComponent,
        BrowserSpecificationComponent,
        IssueStatisticsSummaryComponent,
        TestStatusComponent,
        LiveExpeditionSpecComponent,
        OfflineExpeditionSpecComponent,
        TestStatusSwitcherComponent
    ]
})
export class TestmgmtModule {}
